<template>
  <component
    :is="horizontal ? 'card-horizontal' : 'card-stacked'"
    :image-src="imageSrc"
    :image-alt="imageAlt"
    :title="title"
    :text="text"
    :call-to-action="callToAction"
    :target="target"
    :slides="slides"
    :autoplay="autoplay"
  >
    <template v-slot:image><slot name="image"></slot></template>
    <template v-slot:content> <slot name="content"> </slot></template>
  </component>
</template>

<script>
import cardMixin from '@/components/card/card.mixin'
import CardHorizontal from '@/components/card/CardHorizontal'
import CardStacked from '@/components/card/CardStacked'

export default {
  components: {
    CardHorizontal,
    CardStacked,
  },
  mixins: [cardMixin],
  props: {
    horizontal: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
